import { object, string, ValidationError } from 'yup'

import { AlmacenInputProps } from '../interfaces'

export const almacenRegistroValidator = async (
  input: AlmacenInputProps,
): Promise<Array<string>> => {
  const schema = object({
    nombre: string().required('Ingrese el nombre del Almacen'),
    ubicacion: string().required('Ingrese la Ubicación'),
    codigoSucursal: object().required('Seleccione la Sucursal'),
  })
  try {
    await schema.validate(input, { abortEarly: false })
    return []
  } catch (error) {
    if (error instanceof ValidationError) {
      const errors: Array<string> = error.inner.map((err) => err.message)
      return errors
    } else {
      throw error
    }
  }
}

export const AlmacenRegistroValidationSchema = object({
  nombre: string().required('Ingrese el nombre del Almacen'),
  ubicacion: string().required('Ingrese la Ubicación'),
  codigoSucursal: object().required('Seleccione la Sucursal'),
})
